import {routesEndpoints} from '../../shared/routes/endpoint';

export default routesEndpoints;